import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    domain : 'agro',
    type: {
        isAgro: true,
        isPastoral: false,
    }
}

export const domainSlice = createSlice({
    name: 'domain',
    initialState,
    reducers: {
        editDomain: (state, action) => {
            state.domain = action.payload
            if (action.payload === 'agro') {
                state.type = {
                    isAgro: true,
                    isPastoral: false,
                }
            }
            if (action.payload === 'pastoral') {
                state.type = {
                    isAgro: false,
                    isPastoral: true,
                }
            }
        }
    }
})

export const {
	editDomain,
} = domainSlice.actions
export default domainSlice.reducer